import { useEffect, MouseEvent } from 'react'
import { Box, TablePagination, Toolbar } from '@mui/material'
import { PAGINATOR_OPTIONS } from '../../config'
import { PaginatorProps } from '../../types'
import useUserStorage from '../../hooks/useUserStorage'

interface FooterPaginatorProps {
    total: number,
    withPaginator: PaginatorProps
    setWithPaginator: (data: PaginatorProps) => void
}

export default function FooterPaginator(paginator: Readonly<FooterPaginatorProps>) {
    const listPerPagePreferences = useUserStorage<number>('listPerPagePreferences')
    const handleChangePage = (_: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        paginator?.setWithPaginator({ ...paginator.withPaginator, page: newPage })
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let newPerPageValue = parseInt(event.target.value, 10)
        listPerPagePreferences.setData(newPerPageValue)
        paginator?.setWithPaginator({ page: 0, perPage: newPerPageValue })
    }

    useEffect(() => {
        paginator?.setWithPaginator({ ...paginator.withPaginator, page: 0 })
    }, [paginator?.total])

    return (
        <Toolbar >
            <Box sx={{ flexGrow: 1 }} />
            <TablePagination
                component="div"
                count={paginator.total}
                page={paginator.withPaginator.page}
                onPageChange={handleChangePage}
                rowsPerPage={paginator.withPaginator.perPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={PAGINATOR_OPTIONS}
                labelRowsPerPage={"Por página:"}
                labelDisplayedRows={({ from, to, count }) => `${from} a ${to} de ${count !== -1 ? count : `más de ${to}`}`}
            />
            <Box sx={{ flexGrow: 1 }} />
        </Toolbar>
    )
}
